import { createUseStyles } from 'react-jss';
export default createUseStyles(function (theme) {
  return {
    container: {
      borderRadius: '50%',
      width: 42,
      height: 42,
      backgroundColor: 'transparent',
      borderTopColor: 'transparent',
      border: "5px solid ".concat(theme.palette.text)
    },
    primary: {
      borderColor: theme.palette.primary.regular,
      borderTopColor: 'transparent'
    },
    secondary: {
      borderColor: theme.palette.secondary.regular,
      borderTopColor: 'transparent'
    },
    success: {
      borderColor: theme.palette.success.regular,
      borderTopColor: 'transparent'
    },
    warning: {
      borderColor: theme.palette.warning.regular,
      borderTopColor: 'transparent'
    },
    danger: {
      borderColor: theme.palette.danger.regular,
      borderTopColor: 'transparent'
    }
  };
});